import { FC } from "react"
import { Link, useLocation } from "react-router-dom"
import queryString from 'query-string'



export const LinkPaymentStatus: FC = () => {

    const { search } = useLocation()
    const queryStringParams = queryString.parse(search)

    const paymnetStatus = queryStringParams.PAYMENT_STATUS?.toString()
    const paymnetStatusMessage = queryStringParams.PAYMENT_STATUS_MESSAGE?.toString()
    const paymentId = queryStringParams.PAYMENT_ID?.toString() ?? queryStringParams.PAYMENT_İD?.toString();
    const orderId = queryStringParams.ORDER_ID?.toString() ?? queryStringParams.ORDER_İD?.toString();

    const handleDownloadRecipt = () => {
        const pdfUrl = `https://www.africau.edu/images/default/sample.pdf?paymentId=${paymentId}`;
        const link = document.createElement("a");
        link.href = pdfUrl;
        link.target = "_blank";
        link.download = "Test.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    return (
        <>
            <h2>{paymnetStatus == "10" ? "Ödeme Başarıyla Tamamlandı." : "Ödeme Esnasında Hata Alındı"}</h2>
            <div>{paymnetStatus == "10" ? "'Dekont İndir' butonuna tıklayarak dekontunuzu saklayabilirsiniz" : paymnetStatusMessage}</div>
            <div className='text-center'>
                {
                    paymnetStatus != "10" && (
                        <Link to={`/public/linkpayment/pay?token=${orderId}`} className="btn btn-sm btn-success mb-5">Tekrar Dene</Link>
                    )
                }
                {
                    paymnetStatus == "10" && (
                        <button className='btn btn-sm btn-primary mb-5' onClick={handleDownloadRecipt}>Dekont İndir</button>
                    )
                }
            </div>
        </>
    )
}